import React, { useState } from 'react';
import { Modal } from 'antd';
import ErrorFallback, { type ErrorFallbackProps } from '..';

const ErrorFacllbackModal: React.FC<ErrorFallbackProps> = props => {
  const [open, setOpen] = useState(true);
  return (
    <Modal
      open={open}
      footer={null}
      onCancel={() => setOpen(false)}
      width={500}
      closable
      // centered
      className="error-fallback-modal"
    >
      <ErrorFallback {...props} />
    </Modal>
  );
};

export default ErrorFacllbackModal;
